<template>
  <div class="v-wrap">
    <div class="v-box">
      <div class="v-img-box" @click="navTo(0)">
        <img src="../../assets/industry/i-0.jpg" alt="">
      </div>
      <div class="v-img-box" @click="navTo(1)">
        <img src="../../assets/industry/i-1.jpg" alt="">
      </div>
      <!--<div class="v-img-box" @click="navTo(2)">
        <img src="../../assets/industry/i-2.jpg" alt="">
      </div>-->
      <div class="v-img-box" @click="navTo(3)">
        <img src="../../assets/industry/i-3.jpg" alt="">
      </div>
    </div>
  </div>
</template>
<script>
export default {
    methods: {
        navTo(num){
           this.$router.push({name:'interview',params:{index:num}})
        }
    },
};
</script>
<style lang="scss" scoped>
.v-wrap {
  width: 100%;
  min-height: 100vh;
  background: #fff;
  padding:4.5vw;
  box-sizing: border-box;
  .v-img-box {
    width:100%;
    height:44.14vw;
    margin:3vw 0;
    overflow: hidden;
    display: inline-block;
    font-size:0;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
